import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateTaskDto } from "@myapp/contract";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";

export function useCreateTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateTaskDto) =>
      taskApi.create(dto).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
    },
  });
}
